<div class="error-box">
    <div class="error-body text-center">

        <h6 class="error-title text-success">Page of maintenance</h6>
        <h3 class="text-uppercase error-subtitle">¡PAGINA EN MANTENIMIENTO!</h3>
        <p class="text-muted m-t-30 m-b-30">Para poder ofrecer una calidad de excelencia por el momento estamos en proceso de mantenimiento, disculpen las molestias.</p>
        <!--a href="#/dashboard/pedidos" class="btn btn-danger btn-rounded waves-effect waves-light m-b-40">Back to home</a-->
    </div>
</div>